























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BluetoothManager from '@/lib/bluetoothManager';
import CaptureManager, { State } from '@/lib/captureManager';
import { setInterval, clearInterval } from 'timers';
import { DataDef } from 'vue/types/options';
import Sound from '@/lib/sounds';
import LabelSwipe from '@/components/LabelSwipe.vue';

const buttonLabels = {
  correct: 'Correct',
  mistake: 'Mistake',
  undo: 'Change last label',
};

@Component({
  components: { LabelSwipe },
})
export default class Capture extends Vue {

  private bluetooth: BluetoothManager;
  private capture: CaptureManager;
  private startStopButton: any = {
    color: 'green',
    label: 'Start',
  };
  private progressbar: boolean = false;
  private enableLabels: boolean = false;

  private buttonLabels = buttonLabels;

  private sampleCount = 0;
  private labelCount = 0;
  private timerValue: number = 0;
  private timer: Date = new Date();
  private interval: any;

  private sounds = new Sound();

  private soundFeedback: boolean;
  private vibrationFeedback: boolean;
  private swipeInput: boolean;

  private guestureMap = {
    tap: buttonLabels.correct,
    left: buttonLabels.mistake,
    right: buttonLabels.undo,
  };

  public constructor() {
    super();
    const exercise = this.$store.getters.exercise;
    this.bluetooth = new BluetoothManager(this.$store);
    this.capture = new CaptureManager(this.bluetooth, { exercise });
    const settings = this.$store.getters.settings;
    this.soundFeedback = settings.labeling.soundFeedback;
    this.vibrationFeedback = settings.labeling.vibrationFeedback;
    this.swipeInput = settings.input.swipe;
  }

  private beforeRouteLeave(to: any, from: any, next: any) {
    this.capture.save();
    // TODO: might need to be inside promise (end save, then go to next page...)
    next();
  }

  private startStopButtonHandler() {
    switch (this.capture.state) {
      case State.Ready:
        this.startStopButton = { color: 'red', label: 'Stop' };
        this.capture.start();
        this.progressbar = true;
        this.enableLabels = true;
        this.interval = setInterval(this.updateProgress, 100);
        this.timer = new Date();
        break;
      case State.Capturing:
        this.capture.stop();
        this.startStopButton = { color: 'blue', label: 'Save'};
        this.progressbar = false;
        this.enableLabels = false;
        clearInterval(this.interval);
        break;
      case State.Stopped:
        this.capture.save()
        .then( () => {
          this.$router.push('/');
        });
        break;
    }
  }

  private label(event: any) {
    const label: string = event.currentTarget.getAttribute('data_label');
    this.addLabel(label);
  }

  private addLabel(label: string) {
    this.vibrate();
    this.capture.addLabel(label);
    this.playSound(label);
  }

  private updateProgress() {
    this.timerValue = Math.round((Date.now() - this.timer.getTime()) / 1000);
    this.sampleCount = this.capture.getSampleCount();
    this.labelCount = this.capture.getLabelCount();
  }

  private playSound(label: string) {
    if (this.soundFeedback) {
      if (label === 'Correct') {
        this.sounds.correct();
      } else {
        this.sounds.mistake();
      }
    }
  }

  private vibrate() {
    if (this.vibrationFeedback) {
      window.navigator.vibrate(200);
    }
  }

  private guestureHandler(guesture: string) {
    if (guesture in this.guestureMap) {
      const label: string = (this.guestureMap as any)[guesture];
      this.addLabel(label);
    }
  }
}
